import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { useProductsContext } from '@/creditflowresearch/application/Deal/contexts/ProductsContext';
import { getContainer } from '@framework/di/getContainer';
import { TFilterPayload } from '@/creditflowresearch/application/League/Scorecard/types';
import { createContextConfigs, prepareDealDataForProductType } from '@/creditflowresearch/application/Deal/helpers/productGrouping';
import DealRepository from '@/creditflowresearch/infrastructure/repository/DealRepository';

export interface ITileWrapperProps {
  children?: React.ReactNode,
  requiredUserPlan?: UserPlanType,
  additionalFilters?: TFilterPayload,
}

export const withDealByProductContext = <P extends object>(
  Component: React.ComponentType<P>,
) => {
  const WithDealByProductContext: React.FC<P & ITileWrapperProps> = (props) => {
    const { deals } = useParentPageContext();
    const container = getContainer();
    const dealRepository = container.get<DealRepository>(DealRepository);
    const { activeProduct } = useProductsContext();

    const contextConfigs = createContextConfigs(activeProduct, dealRepository);
    return contextConfigs.reduce((wrappedComponent, config) => {
      const { Provider, productType } = config;
      const dealData = prepareDealDataForProductType(deals, productType);
      return (
        <Provider
          deals={ dealData }
          fetch={ config.fetch }
          additionalFilters={ props.additionalFilters }
        >
          { wrappedComponent }
        </Provider>
      );
    }, <Component { ...props } />);
  };

  return WithDealByProductContext;
};
